export interface FAQItem {
  question: string;
  answer: string;
}

export const faqData = {
  en: [
    {
      question: "What is the minimum duration of stay?",
      answer: "The minimum duration of stay is 4 nights, except for the weekend package."
    },
    {
      question: "What does the weekend package include?",
      answer: "The weekend package includes a 2-night apartment rental, check-in on Friday from 14:00, and check-out on Sunday by 18:00."
    },
    {
      question: "What is prohibited at Bella apartments?",
      answer: "Parties are not allowed, and the apartments are not pet-friendly."
    },
    {
      question: "How are the apartments equipped?",
      answer: "Each apartment has bedding, towels, a fully equipped kitchen, refrigerator, bathroom with a shower, terrace with a lake view, Wi-Fi, TV with satellite channels, barbecue, fireplace, and secured parking."
    },
    {
      question: "Are prices different during holidays?",
      answer: "Yes, prices are different during holidays."
    },
    {
      question: "Is it possible to rent an apartment for one night?",
      answer: "No, apartments are not rented for one night."
    },
    {
      question: "How to get to Bella apartments?",
      answer: "The apartments can be reached via Bovn (5 km of dirt road), through the village Mozgova, or by boat (3-5 minutes)."
    },
    {
      question: "What activities are available on the lake?",
      answer: "Activities include swimming, fishing with a permit, rowing, hiking, walking, and mushroom picking."
    },
    {
      question: "Is it possible to rent a boat or kayak?",
      answer: "Yes, it is possible to rent a boat, kayak, and sandoline upon request."
    },
    {
      question: "What are the check-in and check-out times?",
      answer: "Check-in is from 14:00, and check-out is by 10:00, except for the weekend variant, which is until 18:00 on Sunday."
    },
    {
      question: "Is swimming allowed in the lake?",
      answer: "Yes, swimming is allowed, and the beach is located in front of the apartments."
    },
    {
      question: "Why choose Bella apartments?",
      answer: "Bella apartments offer privacy, spacious terraces with a lake view, and an opportunity to rest in the untouched nature of Bovansko Lake, with friendly hosts always available."
    }
  ],
  de: [
    {
      question: "Was ist die Mindestdauer des Aufenthalts?",
      answer: "Die Mindestdauer des Aufenthalts beträgt 4 Nächte, außer bei einem Wochenendpaket."
    },
    {
      question: "Was beinhaltet das Wochenendpaket?",
      answer: "Das Wochenendpaket beinhaltet eine 2-Nächte-Wohnungsvermietung, Check-in am Freitag ab 14:00 Uhr und Check-out am Sonntag bis 18:00 Uhr."
    },
    {
      question: "Was ist in den Bella-Apartments verboten?",
      answer: "Partys sind nicht erlaubt und die Apartments sind nicht haustierfreundlich."
    },
    {
      question: "Wie sind die Apartments ausgestattet?",
      answer: "Jedes Apartment ist mit Bettwäsche, Handtüchern, einer voll ausgestatteten Küche, einem Kühlschrank, einem Badezimmer mit Dusche, einer Terrasse mit Seeblick, WLAN, einem Fernseher mit Satellitenkanälen, einem Grill, einem Kamin und einem gesicherten Parkplatz ausgestattet."
    },
    {
      question: "Sind die Preise an Feiertagen unterschiedlich?",
      answer: "Ja, die Preise sind an Feiertagen unterschiedlich."
    },
    {
      question: "Ist es möglich, ein Apartment für eine Nacht zu mieten?",
      answer: "Nein, Apartments werden nicht für eine Nacht vermietet."
    },
    {
      question: "Wie gelangt man zu den Bella-Apartments?",
      answer: "Die Apartments können über Bovn (5 km Schotterstraße), durch das Dorf Mozgova oder mit dem Boot (3-5 Minuten) erreicht werden."
    },
    {
      question: "Welche Aktivitäten sind am See möglich?",
      answer: "Zu den Aktivitäten gehören Schwimmen, Angeln mit Erlaubnis, Rudern, Wandern, Spaziergänge und Pilzesammeln."
    },
    {
      question: "Ist es möglich, ein Boot oder Kajak zu mieten?",
      answer: "Ja, es ist möglich, ein Boot, Kajak oder Sandoline auf Anfrage zu mieten."
    },
    {
      question: "Wie sind die Check-in- und Check-out-Zeiten?",
      answer: "Check-in ist ab 14:00 Uhr und Check-out bis 10:00 Uhr, außer für die Wochenend-Variante, die bis 18:00 Uhr am Sonntag dauert."
    },
    {
      question: "Ist Schwimmen im See erlaubt?",
      answer: "Ja, Schwimmen ist erlaubt, und der Strand befindet sich vor den Apartments."
    },
    {
      question: "Warum Bella-Apartments wählen?",
      answer: "Die Bella-Apartments bieten Privatsphäre, geräumige Terrassen mit Seeblick und die Möglichkeit, sich in der unberührten Natur des Bovansko-Sees zu erholen, mit freundlichen Gastgebern, die immer zur Verfügung stehen."
    }
  ],
  sr: [
    {
      question: "Koje je minimalno trajanje boravka?",
      answer: "Minimalno trajanje boravka je 4 noći, osim u slučaju vikend paketa."
    },
    {
      question: "Šta uključuje vikend paket?",
      answer: "Vikend paket uključuje najam apartmana za 2 noći, check-in u petak od 14:00 i check-out u nedelju do 18:00."
    },
    {
      question: "Šta je zabranjeno u Bella apartmanima?",
      answer: "Žurke nisu dozvoljene, a apartmani nisu pet friendly."
    },
    {
      question: "Kako su apartmani opremljeni?",
      answer: "Svaki apartman ima posteljinu, peškire, kompletno opremljenu kuhinju, frižider, kupatilo sa tuš kabinom, terasu sa pogledom na jezero, WiFi, TV sa satelitskom televizijom, roštilj, kamin i obezbeđen parking."
    },
    {
      question: "Da li su cene različite tokom praznika?",
      answer: "Da, cene za praznike se razlikuju."
    },
    {
      question: "Da li je moguće iznajmiti apartman na jednu noć?",
      answer: "Ne, apartmani se ne izdaju na jednu noć."
    },
    {
      question: "Kako se dolazi do Bella apartmana?",
      answer: "Do apartmana se može doći preko Bovna (5 km zemljanog puta), preko sela Mozgova ili čamcem (3-5 minuta)."
    },
    {
      question: "Koje aktivnosti su dostupne na jezeru?",
      answer: "Aktivnosti uključuju kupanje, pecanje uz dozvolu, veslanje, planinarenje, šetnje i branje pečurki."
    },
    {
      question: "Da li je moguće iznajmljivanje čamca ili kajaka?",
      answer: "Da, moguće je iznajmljivanje čamca, kajaka i sandoline na upit."
    },
    {
      question: "Kakvo je radno vreme za check-in i check-out?",
      answer: "Check-in je od 14:00, a check-out do 10:00, osim za vikend varijantu kada je do 18:00 u nedelju."
    },
    {
      question: "Da li je kupanje u jezeru dozvoljeno?",
      answer: "Da, kupanje je dozvoljeno, a plaža se nalazi ispred apartmana."
    },
    {
      question: "Zašto izabrati Bella apartmane?",
      answer: "Bella apartmani nude privatnost, prostrane terase sa pogledom na jezero i priliku za odmor u netaknutoj prirodi Bovanskog jezera, uz ljubazne domaćine koji su uvek na raspolaganju."
    }
  ]
};
